import * as React from 'react';
import { Modal as AntdModal } from 'antd';
import './modal.scss';
import { CloseOutlined } from '@ant-design/icons';

interface Props {
    title?: string;
    isOpen: boolean;
    children: React.ReactNode;
    className?: string;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    onClose?: () => void;
}

export const Modal: React.FC<Props> = (props) => {
    const onCloseHandle = () => {
        props.setIsOpen(false);
        props.onClose && props.onClose();
    };

    return (
        <>
            <AntdModal
                title={props.title}
                open={props.isOpen}
                className={`pmx-modal ${props.className ? props.className : ''}`}
                wrapClassName="pmx-modal-wrap"
                onCancel={onCloseHandle}
                closable
                keyboard
                focusTriggerAfterClose
                centered
                maskClosable
                footer={null}
                mask
                destroyOnClose
                closeIcon={<CloseOutlined onClick={onCloseHandle} />}
            >
                {props.children}
            </AntdModal>
        </>
    );
};
